export const IMAGE_UPLOAD_ACCEPT =
  '.jpg,.jpeg,.png,.bmp,image/jpeg,image/png,image/bmp';

export const IMAGE_UPLOAD_EXTENSIONS = ['jpg', 'jpeg', 'png', 'bmp'];

export const IMAGE_UPLOAD_MIME_TYPES = ['image/jpeg', 'image/png', 'image/bmp'];

/** 1 KB */
export const IMAGE_UPLOAD_MIN_BYTES = 1024;

/** 10 MB */
export const IMAGE_UPLOAD_MAX_BYTES = 10 * 1024 * 1024;

export const IMAGE_UPLOAD_ERROR = {
  INVALID_TYPE: 'Only image files (PNG, JPG, JPEG, BMP) are allowed.',
  SIZE_OUT_OF_RANGE: 'Image size must be at least 1 KB and not more than 10 MB.'
} as const;

/** Returns a user-facing error message key, or null when the file is valid. */
export function getImageUploadValidationError(file: File | null | undefined): string | null {
  if (!file) {
    return IMAGE_UPLOAD_ERROR.INVALID_TYPE;
  }

  const extension = file.name.includes('.')
    ? file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase()
    : '';

  const hasValidExtension = IMAGE_UPLOAD_EXTENSIONS.includes(extension);
  const hasValidMime = !file.type || IMAGE_UPLOAD_MIME_TYPES.includes(file.type);

  if (!hasValidExtension || !hasValidMime) {
    return IMAGE_UPLOAD_ERROR.INVALID_TYPE;
  }

  if (file.size < IMAGE_UPLOAD_MIN_BYTES || file.size > IMAGE_UPLOAD_MAX_BYTES) {
    return IMAGE_UPLOAD_ERROR.SIZE_OUT_OF_RANGE;
  }

  return null;
}
